import React from 'react';

const ResponsiveTableCell = props => (
  <li
    className={`cell ${props.className ? props.className : ''}`}
    key={`table-cell-${props.index}`}
  >
    <h6 className="header">
      <span className="header-intern">{props.headers[props.index].title}</span>
    </h6>
    <div className="content">{props.children}</div>
  </li>
);

export default ResponsiveTableCell;



// WEBPACK FOOTER //
// ./app/javascript/common/components/responsive-table-cell.js